import React from 'react';

import { IconsEnum } from '../../../../../../../assets/icons/types';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { Files } from '../../../../../../../utils/Files';

import { MaterialsListItemOpenLightboxButtonMaterial } from './MaterialsListItemOpenLightboxButton.types';

interface MaterialsListItemOpenLightboxButtonProps {
  material: MaterialsListItemOpenLightboxButtonMaterial;
  onLightboxOpen: () => void;
}

function MaterialsListItemOpenLightboxButton({
  material,
  onLightboxOpen
}: MaterialsListItemOpenLightboxButtonProps) {
  const hasImage = material.image?.file && Files.isImage(material.image.file);

  if (!hasImage) {
    return null;
  }

  return (
    <PureTooltipIconButtonHelper
      className="bg-white dark:bg-gray-900 dark:hover:bg-gray-700 dark:text-gray-300 focus:ring-offset-0 font-medium hover:bg-gray-200 inline-flex items-center p-1 rounded-md text-gray-700 text-sm pointer-events-auto shadow dark:glow"
      dataGa="materials-material-open-lightbox-button"
      icon={IconsEnum.ARROWS_EXPAND_SOLID}
      iconClassName="h-5 w-5"
      tooltipI18nText="words.expand_view"
      tooltipSingleton
      onClick={onLightboxOpen}
    />
  );
}

export default MaterialsListItemOpenLightboxButton;
